import { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'

import { ServiceModel } from '../../../domain/models'

import { formatDate } from '../../utils'
import { useModalBox } from '../../contexts'
import { AlertModal, ValidadeReportForm } from '..'

import DeleteServiceModal from './delete-service'

import {
  IconArrowLeftSvg,
  IconMinusSvg,
  IconPlusSvg,
  IconEditSvg,
  IconTrashSvg
} from '../../assets/icons/svgComponents'

type ItemAccordionModel = {
  idCustomer: string | number
  handleOpenEditModal: any
  item: ServiceModel
  lengthServices: number
}

const ItemAccordion = ({
  idCustomer,
  handleOpenEditModal,
  item,
  lengthServices
}: ItemAccordionModel) => {
  const [accordionOpen, setAccordionOpen] = useState(true)
  const { modalBox } = useModalBox()
  const history = useHistory()

  const handleClick = () => {
    setAccordionOpen(!accordionOpen)
  }

  const handleOpenValidateModal = (type: string) => {
    modalBox(
      <ValidadeReportForm
        type={type}
        assessment={item}
        idCustomer={idCustomer}
      />,
      'Validação de dados',
      '46%',
      item?.aplicacaoTeste?.realizado &&
        item?.entrevista?.realizado &&
        item?.observacaoComportamental?.realizado
        ? 'auto'
        : type === 'laudo'
        ? '80%'
        : 'auto'
    )
  }

  const handleOpenDeleteModal = () => {
    modalBox(<DeleteServiceModal item={item} />, 'Deletar serviço', '32%')
  }
  const handleOpenPsychologicalInterviewModal = () => {
    if (item?.entrevista?.realizado === true) {
      history.push(
        `/meus-pacientes/${idCustomer}/avaliacao-psicologica/entrevista/${
          item.cdServico
        }/${false}`
      )
      return
    }

    if (lengthServices > 1) {
      modalBox(
        <AlertModal idCustomer={idCustomer} cdServico={item.cdServico} />,
        'Preencher entrevista',
        '32%'
      )
    } else {
      history.push(
        `/meus-pacientes/${idCustomer}/avaliacao-psicologica/entrevista/${
          item.cdServico
        }/${false}`
      )
    }
  }
  useEffect(() => {
    if (item?.dataFinal) {
      setAccordionOpen(false)
    }
  }, [item?.dataFinal])

  return (
    <>
      <tr>
        <td className="main-row">
          {' '}
          <div className="clickable-div" onClick={handleClick}>
            {formatDate(item.dataServico)} - {item.demanda}
          </div>
          <div className="buttons-wrapper">
            <button
              className="edit-button"
              onClick={() => handleOpenEditModal(item)}
            >
              <IconEditSvg />
            </button>
            <button className="trash-button" onClick={handleOpenDeleteModal}>
              <IconTrashSvg />
            </button>
            <button className="plus-button" onClick={handleClick}>
              {accordionOpen ? <IconMinusSvg /> : <IconPlusSvg />}
            </button>
          </div>
        </td>
      </tr>
      <tr>
        <td className={accordionOpen ? 'collapse active' : 'collapse'}>
          <div className="collapse-content">
            <h4>Avaliação Psicológica</h4>
            <h3
              className="reports-link"
              onClick={() => handleOpenPsychologicalInterviewModal()}
            >
              Entrevista Psicológica
              {item?.entrevista?.realizado ? (
                <div className="tags-collapse">
                  <p>Realizado</p>
                  <IconArrowLeftSvg />
                </div>
              ) : (
                <IconArrowLeftSvg />
              )}
            </h3>
            <Link
              to={`/meus-pacientes/${idCustomer}/avaliacao-psicologica/aplicacao-de-teste/${item.cdServico}`}
            >
              Aplicação de Teste
              {item?.aplicacaoTeste?.realizado ? (
                <div className="tags-collapse">
                  <p>Realizado</p>
                  <IconArrowLeftSvg />
                </div>
              ) : (
                <IconArrowLeftSvg />
              )}
            </Link>
            <Link
              to={`/meus-pacientes/${idCustomer}/avaliacao-psicologica/observacao-comportamental/${item.cdServico}`}
            >
              Observação Comportamental
              {item?.observacaoComportamental?.realizado ? (
                <div className="tags-collapse">
                  <p>Realizado</p>
                  <IconArrowLeftSvg />
                </div>
              ) : (
                <IconArrowLeftSvg />
              )}
            </Link>
            <h4>Documentos Psicológicos</h4>
            {item?.aplicacaoTeste?.realizado &&
            item?.observacaoComportamental?.realizado &&
            item?.entrevista?.realizado &&
            item?.todosOsDadosCompletosDoLaudo ? (
              <Link
                to={`/meus-pacientes/${idCustomer}/avaliacao-psicologica/laudo/${item.cdServico}`}
              >
                Laudo
                {item?.observacaoComportamental?.realizado ? (
                  <div className="tags-collapse">
                    <p>Emitido</p>
                    <IconArrowLeftSvg />
                  </div>
                ) : (
                  <IconArrowLeftSvg />
                )}
              </Link>
            ) : (
              <div
                className="reports-link"
                onClick={() => handleOpenValidateModal('laudo')}
              >
                Laudo
                {item?.laudo?.realizado ? (
                  <div className="tags-collapse">
                    <p>Emitido</p>
                    <IconArrowLeftSvg />
                  </div>
                ) : (
                  <IconArrowLeftSvg />
                )}
              </div>
            )}
            {item?.todosOsDadosCompletosDoAtestado ? (
              <Link
                to={`/meus-pacientes/${idCustomer}/avaliacao-psicologica/atestado/${item.cdServico}`}
              >
                Atestado
                {item?.atestado?.realizado ? (
                  <div className="tags-collapse">
                    <p>Emitido</p>
                    <IconArrowLeftSvg />
                  </div>
                ) : (
                  <IconArrowLeftSvg />
                )}
              </Link>
            ) : (
              <div
                className="reports-link"
                onClick={() => handleOpenValidateModal('atestado')}
              >
                Atestado
                {item?.atestado?.realizado ? (
                  <div className="tags-collapse">
                    <p>Emitido</p>
                    <IconArrowLeftSvg />
                  </div>
                ) : (
                  <IconArrowLeftSvg />
                )}
              </div>
            )}
            <Link
              to={`/meus-pacientes/${idCustomer}/avaliacao-psicologica/relatorio/${item.cdServico}`}
            >
              Relatório
              {item?.relatorio?.realizado ? (
                <div className="tags-collapse">
                  <p>Emitido</p>
                  <IconArrowLeftSvg />
                </div>
              ) : (
                <IconArrowLeftSvg />
              )}
            </Link>
            <Link
              to={`/meus-pacientes/${idCustomer}/avaliacao-psicologica/parecer/${item.cdServico}`}
            >
              Parecer
              {item?.parecer?.realizado ? (
                <div className="tags-collapse">
                  <p>Emitido</p>
                  <IconArrowLeftSvg />
                </div>
              ) : (
                <IconArrowLeftSvg />
              )}
            </Link>
            {item?.todosOsDadosCompletosDoAtestado ? (
              <Link
                to={`/meus-pacientes/${idCustomer}/avaliacao-psicologica/declaracao/${item.cdServico}`}
              >
                Declaração
                {item?.declaracao?.realizado ? (
                  <div className="tags-collapse">
                    <p>Emitido</p>
                    <IconArrowLeftSvg />
                  </div>
                ) : (
                  <IconArrowLeftSvg />
                )}
              </Link>
            ) : (
              <div
                className="reports-link"
                onClick={() => handleOpenValidateModal('declaração')}
              >
                Declaração
                {item?.declaracao?.realizado ? (
                  <div className="tags-collapse">
                    <p>Emitido</p>
                    <IconArrowLeftSvg />
                  </div>
                ) : (
                  <IconArrowLeftSvg />
                )}
              </div>
            )}
          </div>
        </td>
      </tr>
    </>
  )
}

export default ItemAccordion
